<template>
  <div>
    <h1>Oops. Page not found. ¯\_(ツ)_/¯</h1>
  </div>
</template>

<script>
export default {
}
</script>

<style scoped>
</style>
